import * as yup from "yup";

export default yup.object().shape({
  subject: yup.string().min(2).max(100).required(),
  to: yup.array().min(1).required(),

});